import t from"react";import{MdIcon as r}from"./MdIcon.js";import{mdiInstagram as m}from"@mdi/js";const i=({id:i="instagram",title:o="Instagram",...e})=>t.createElement(r,{id:i,title:o,path:m,...e});export{i as InstagramIcon};
